// extracted by mini-css-extract-plugin
module.exports = {"none":"pointerEvents-module__none___8jwag"};